import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserStorageService } from './browser-storage.service';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private isAuthenticated: boolean = false;
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private browserStorage: BrowserStorageService,
    private encryptionService: EncryptionService
  ) { }

  loadAuthData(): Promise<any> {
    return new Promise((resolve) => {
      const isBrowser = isPlatformBrowser(this.platformId);
      if (!isBrowser) {
        this.isAuthenticated = false;
        resolve(true);
        return;
      }
      const accessToken = this.browserStorage.getSessionStorageItem('access');
      const encryptedUser = this.browserStorage.getSessionStorageItem('user');
      const storagedUser = encryptedUser ? this.encryptionService.decrypt(encryptedUser) : null;
      const userObject = storagedUser ? JSON.parse(storagedUser) : null;

      let isValidToken = !!accessToken; // Check for access token presence

      if (isValidToken && userObject) {
        // Validate user properties for full authentication
        isValidToken = userObject.is_authenticator_activated && userObject.is_active;
      } else {
        isValidToken = false; // No access token or user object, so not authenticated
      }
      
      this.isAuthenticated = isValidToken;

      resolve(true); 
    });
  }

  isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  setAuthenticated(value: boolean): void {
    this.isAuthenticated = value;
  }
}
